export default __webpack_public_path__ + "static/media/courseCardImage.cfe1e117.svg";